export const LINKS_STYLE = {
  textDecoration: "underline",
  textUnderlineOffset: "3px"
}
